import { Grid } from '@mui/material';
import { PlanEditMap } from './plan-edit-map';
import { PlanEditTabs } from './plan-edit-tabs';

export const PlanEdit = () => {
  return (
    <Grid container wrap="nowrap" style={{ width: `100%`, height: `100%` }}>
      <PlanEditTabs />
      <PlanEditMap />
    </Grid>
  );
};
